/** get data from OBI
 * @param {string} portName - name of the port
 * @param {object} boxDetails - complete box object
 * @param {string} key - value to be extracted from obi object
 * @returns {string | object} - returns key value if provided or complete box object
 */
 const getObiData = (portName, boxDetails, key) => {
  const portSelected = portName.split(' ');
  const obiIndex = Math.round((parseInt(portSelected[1]) + 0.5) / 2);
  if (key) {
    if (key === 'portName') {
      portSelected[1] = obiIndex;
      return portSelected.join('').toLowerCase();
    }
    if (key === 'portIndex') return obiIndex;

    return boxDetails.Obis.length === 1
      ? boxDetails.Obis[0][key]
      : boxDetails.Obis[obiIndex - 1][key];
  }
  return boxDetails.Obis.length === 1 ? boxDetails.Obis[0] : boxDetails.Obis[obiIndex - 1];
};


export { getObiData };
export default getObiData;
